export default __webpack_public_path__ + "static/media/daylotts_privacy_policy.f9e36f94.pdf";